import axios from 'axios';

export const ordersService = {
    getOrders: () => axios.get(`/orders`, { auth: true }),

    ordersPost: (data) => axios.post(`/orders`, { ...data }),
};
